module.exports = __webpack_public_path__ + "static/media/icon_smart_leverage.1c993c19.svg";